import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "inline-block" }


export default /*#__PURE__*/_defineComponent({
  __name: 'NumberBadge',
  props: {
  badgeNumber: { type: [String, Number], required: true },
  isEnabled: { type: Boolean, default: true },
  color: { type: String, default: 'primary', validator: (value: string) => ['white', 'primary'].includes(value) }
},
  setup(__props) {




return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: _normalizeClass(["h-4 px-1 rounded flex justify-center", {
        'bg-primary-500': __props.isEnabled && __props.color === 'primary',
        'bg-white': __props.isEnabled && __props.color === 'white',
        'bg-gray-100': !__props.isEnabled,
      }]),
      "data-dusk": "badge-container"
    }, [
      _createElementVNode("div", {
        class: _normalizeClass(["text-2xs font-semibold self-center", {
          'text-white bg-primary-500': __props.isEnabled && __props.color === 'primary',
          'text-primary-500 bg-white': __props.isEnabled && __props.color === 'white',
          'text-gray-600 bg-gray-100': !__props.isEnabled,
        }]),
        "data-dusk": "badge-number"
      }, _toDisplayString(__props.badgeNumber), 3)
    ], 2)
  ]))
}
}

})